import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  pipCoverageCard: {
    width: 720,
    borderRadius: theme.sizes.roundCorners,
    padding: 32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24
  },
  pipMEContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: theme.spacing(-4)
  },
  separator: {
    width: '100%',
    borderBottom: `1px solid ${theme.colorPalette.green_75}`,
    margin: theme.spacing(-2, 0, -1)
  },
  radioContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(-2)
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  pipEligibilityText: {
    color: theme.colorPalette.beige_75,
    fontSize: 11,
    fontStyle: 'italic',
    fontWeight: 400,
    marginLeft: theme.spacing(-2)
  },
  columnContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  warningContainer: {
    backgroundColor: theme.colorPalette.green_90,
    padding: '8px 0px 8px 40px',
    marginTop: theme.spacing(-2),
    color: theme.colorPalette.white
  },
  infoCard: {
    width: 616,
    gap: 8,
    backgroundColor: theme.colorPalette.green_100,
    padding: '16px 16px 8px',
    marginBottom: 8,
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'row',
    fontSize: 14
  },
  iconSmall: {
    height: 16,
    marginTop: 6
  },
  iconAllOptOut: {
    height: 16,
    marginTop: 16
  },
  notificationContentWithTitle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: theme.colorPalette.white,
    marginTop: -10
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: 14,
    marginBottom: 4
  }
}));

export default useStyles;
